import React, { forwardRef } from 'react';
import { howToPlayUrl, amazonLink, etsyLink } from './constants/Constants';
import { useNavigate } from "react-router-dom";

const Menu = forwardRef<HTMLDivElement>((_, ref) => {
    const navigate = useNavigate();

    const handleAmazonClick = () => {
        window.open(amazonLink, '_blank');
    }

    const handleEtsyClick = () => {
        window.open(etsyLink, '_blank');
    }

    const handlePlayClick = () => {
        navigate("/play");
    }

    const handleEventsClick = () => {
        
    }

    const handleHowToPlayClick = () => {
        window.open(howToPlayUrl, '_blank');
    }

    const handleBlogClick = () => {
        
    }

    return (
        <div className="menuWrapper" ref={ref}>
            <div className="menuItem" tabIndex={0} onClick={handleAmazonClick} onKeyDown={(e) => {
                if (e.key === "Enter") {
                    handleAmazonClick();
                }
            }}>AMAZON</div>
            <div className="menuItem" tabIndex={0} onClick={handleEtsyClick} onKeyDown={(e) => {
                if (e.key === "Enter") {
                    handleEtsyClick();
                }
            }}>ETSY</div>
            <div className="menuItem" tabIndex={0} onClick={handlePlayClick} onKeyDown={(e) => {
                if (e.key === "Enter") {
                    handlePlayClick();
                }
            }}>PLAY ONLINE</div>
            <div className="menuItem" tabIndex={0} onClick={handleEventsClick} onKeyDown={(e) => {
                if (e.key === "Enter") {
                    handleEventsClick();
                }
            }}>EVENTS</div>
            <div className="menuItem" tabIndex={0} onClick={handleHowToPlayClick} onKeyDown={(e) => {
                if (e.key === "Enter") {
                    handleHowToPlayClick();
                }
            }}>HOW TO PLAY</div>
            <div className="menuItem" tabIndex={0} onClick={handleBlogClick} onKeyDown={(e) => {
                if (e.key === "Enter") {
                    handleBlogClick();
                }
            }}>BLOG</div>
        </div>
    )
});

export default Menu;